import React from 'react'
import PropTypes from 'prop-types'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'

import { checkoutApp } from './GlobalStateContainer'
import CheckoutComponents from './Features/CheckoutComponents'
import { countriesStatesMap } from './Features/Address/propTypes'
import {
  arrayOfShapesWithIdOfString,
  arrayOfShapesWithIdOfAny  
} from '../util/propTypeShapes'

import mapTopLevelPropsToInitialStoreState from './GlobalStateContainer/mapTopLevelPropsToInitialStore'

// props should contain all data we want to initialize the app with
class Checkout extends React.Component{
  constructor(props) {
    super(props);
    
    let initialStoreState = mapTopLevelPropsToInitialStoreState(props);

    // Create store
    this.store = createStore(
      checkoutApp,
      initialStoreState,
      // Initialize cr
      composeWithDevTools(
        applyMiddleware(
          // Setup library to help with async actions
          thunkMiddleware,
          // Setup console action logger middleware
          createLogger()
      )));

  }

  // Make Store available to components, and instantiate checkout components
  render() {
    return (
      <Provider store={this.store}>
        <CheckoutComponents />
      </Provider>
    );
  }
}

Checkout.propTypes = {
  initialData: PropTypes.shape({
      BillingAddresses: arrayOfShapesWithIdOfString.isRequired,
      ShippingAddresses: arrayOfShapesWithIdOfString.isRequired,
      CartItems: arrayOfShapesWithIdOfAny.isRequired,
      HasRestrictedItems: PropTypes.bool.isRequired,
      PaymentOptions: arrayOfShapesWithIdOfString.isRequired,
      ShippingOptions: arrayOfShapesWithIdOfString.isRequired,
      CheckoutSummary: PropTypes.shape({
        Total: PropTypes.number.isRequired,    
        SubTotal: PropTypes.number.isRequired,    
        ShippingTotal: PropTypes.number.isRequired
      }).isRequired,
      AllowBillingEqualsShipping: PropTypes.bool.isRequired,
      DisableBillingChanges: PropTypes.bool.isRequired,
      SiteKey: PropTypes.string,
      CheckoutEnvironmentMessage: PropTypes.string,
    }
  ).isRequired,
    PhoneNumber: PropTypes.string,
    PhoneText: PropTypes.string,
    ReceiptUrl: PropTypes.string,
    CheckoutUrl: PropTypes.string,
    addAddressEndpoint: PropTypes.string,
    deleteAddressEndpoint: PropTypes.string,
    placeOrderEndpoint: PropTypes.string.isRequired,
    countries: PropTypes.arrayOf(
      PropTypes.shape({
        Name: PropTypes.string.isRequired,
        Code: PropTypes.string.isRequired
      })).isRequired,
    ShippingAddressType: PropTypes.number.isRequired,
    BillingAddressType: PropTypes.number.isRequired,
    countriesStatesMap: PropTypes.objectOf(countriesStatesMap).isRequired,
  BraintreeClientSettings: PropTypes.shape({
    BraintreePaypalEnabled : PropTypes.bool.isRequired,
    BraintreePaypalCreditEnabled:  PropTypes.bool.isRequired,
    BraintreePaypalFlow: PropTypes.string.isRequired,
    BraintreePaymentOptionId: PropTypes.string.isRequired
  }).isRequired
}

export default Checkout



// WEBPACK FOOTER //
// ./src/Components/checkout/CheckoutApp.jsx